export var StageType;
(function (StageType) {
    StageType["MCQ_EXAM"] = "MCQ_EXAM";
    StageType["CODING_TEST"] = "CODING_TEST";
    StageType["INTERVIEW"] = "INTERVIEW";
    StageType["ISA_SIGN"] = "ISA_SIGN";
    StageType["QUIZ"] = "QUIZ";
    StageType["HACKATHON"] = "HACKATHON";
    StageType["CODING_INTERVIEW"] = "CODING_INTERVIEW";
    StageType["BOT_INTERVIEW"] = "BOT_INTERVIEW";
    StageType["ASSIGNMENT"] = "ASSIGNMENT";
    StageType["MANUAL"] = "MANUAL";
    StageType["PENDING_v2"] = "pending";
    StageType["FEEDBACK_PENDING_v2"] = "feedback_pending";
    StageType["COMPLETED_V2"] = "completed";
    StageType["PANEL_INTERVIEW"] = "PANEL_INTERVIEW";
})(StageType || (StageType = {}));
